define([
  /* eslint-disable */
  'js/aofl-js/0.8.0/app/app',
  'readingiq-src/js/riq-js/riq-child-form/1.0.0/js/vm-service/1.0.0/index-impl',
  'readingiq-src/js/riq-js/riq-user-model-service/1.0.0/index',
  'readingiq-src/js/riq-js/riq-group-model-service/1.0.0/index',
  'readingiq-src/js/riq-js/group-state-service/1.0.0/index',
  'readingiq-src/js/riq-js/tag-model-service/1.0.0/index',
  'readingiq-src/js/riq-js/avatar-model-service/1.0.0/index',
  'readingiq-src/js/comprehension-check-js/placement-validate-model-service/1.0.0/index',
  'readingiq-src/onboarding_com_en/js/onboarding-container/1.0.0/js/vm-service/index'
  /* eslint-enable */
], function riqChildFormVmService(app, riqChildFormVmServiceImpl) {
  'use strict';

  app.registerFactory('riqChildFormVmService', [
    'riqUserModelService',
    'riqGroupModelService',
    'tagModelService',
    'avatarModelService',
    'placementModelService',
    'ngDialog',
    '$state',
    riqChildFormVmServiceImpl
  ]);
});
